import { DineoutCartType } from "@checkout-core/contexts/DineoutCartContext";

export enum DINEOUT_CHECKOUT_INITIAL_STATE {
    CONFIRM_ORDER = "CONFIRM_ORDER",
    WALLET_MONEY_RECEIVED = "WALLET_MONEY_RECEIVED",
    PAYMENTS = "PAYMENTS",
    /* for table reservation, these 2 are kept separate and decoupled to make
     * to app compatible also, since on app we might go with just reservation
     * cart for now */
    BILL_PAYMENT_CART = "BILL_PAYMENT_CART",
    TABLE_RESERVATION_CART = "TABLE_RESERVATION_CART",
    EVENT_BOOKING_CART = "EVENT_BOOKING_CART",
    DINEOUT_SUCCESS_SCREEN = "DINEOUT",
    PAYLATER_SIMPL_LINKING_FAILED = "PAYLATER_SIMPL_LINKING_FAILED",
    PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER = "PAYLATER_SIMPL_LINKING_SUCCESS_DONT_PROCEED_WITH_ORDER",
    PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER = "PAYLATER_SIMPL_LINKING_SUCCESS_PROCEED_WITH_ORDER",
    SCENES_FULL_PAYMENT = "SCENES_FULL_PAYMENT",
    /** Key stays STEAL_STORE_CART; URL/state param value is STEAL_DEAL_CART */
    STEAL_STORE_CART = "STEAL_DEAL_CART",
}

export const CART_TYPE_TO_STATE_MAPPING = {
    [DineoutCartType.TABLE_RESERVATION_CART]: DINEOUT_CHECKOUT_INITIAL_STATE.TABLE_RESERVATION_CART,
    [DineoutCartType.BILL_PAYMENT_CART]: DINEOUT_CHECKOUT_INITIAL_STATE.BILL_PAYMENT_CART,
    [DineoutCartType.EVENT_BOOKING_CART]: DINEOUT_CHECKOUT_INITIAL_STATE.EVENT_BOOKING_CART,
    [DineoutCartType.SCENES_FULL_PAYMENT]: DINEOUT_CHECKOUT_INITIAL_STATE.SCENES_FULL_PAYMENT,
    [DineoutCartType.STEAL_STORE_CART]: DINEOUT_CHECKOUT_INITIAL_STATE.STEAL_STORE_CART,
};

// Session storage keys for dineout cart referrer tracking
export const DINEOUT_CART_REFERRER_KEY = "dineout_cart_referrer";
export const DINEOUT_CART_REFERRER_ID_KEY = "dineout_cart_referrer_id";

// Dating flow constants
export const DATING_REFERRER = "dating";

// Query param keys for dating flow
export const REFERRER_QUERY_PARAM = "referrer";
export const REFERRER_ID_QUERY_PARAM = "referrerId";
